export class TenantPlan {
  public name: string;
  public maxPotentialPersons: number;
  public maxPersonFields: number;
  public maxTeamFields: number;
  public maxTrackedFields: number;
  public maxSystemUsers: number;
  public canUseDisplayLogic: boolean;
  public canUploadDocuments: boolean;
  public canSendTeamEmail: boolean;
  public maxActivePersons: number;
  public canSaveViews: boolean;
  public canManageColumns: boolean;
  public maxWorkspaceLimit: number;
  public canScheduleEmailReminders: boolean;
  public canUseAdvancedAttributes: boolean;
  public canUseCalculatedFields: boolean;
  public maxAiTokens: number;

  constructor(obj: Partial<TenantPlan>) {
    this.name = obj.name;
    this.canUseDisplayLogic = obj.canUseDisplayLogic;
    this.canUploadDocuments = obj.canUploadDocuments;
    this.canSendTeamEmail = obj.canSendTeamEmail;
    this.maxActivePersons = obj.maxActivePersons;
    this.canSaveViews = obj.canSaveViews;
    this.maxPotentialPersons = obj.maxPotentialPersons;
    this.maxPersonFields = obj.maxPersonFields;
    this.maxTeamFields = obj.maxTeamFields;
    this.maxTrackedFields = obj.maxTrackedFields;
    this.maxSystemUsers = obj.maxSystemUsers;
    this.canManageColumns = obj.canManageColumns;
    this.canScheduleEmailReminders = obj.canScheduleEmailReminders;
    this.canUseAdvancedAttributes = obj.canUseAdvancedAttributes;
    this.maxAiTokens = obj.maxAiTokens;
    this.maxWorkspaceLimit = obj.maxWorkspaceLimit;
    this.canUseCalculatedFields = obj.canUseCalculatedFields;
  }
}
